import { FETCH_GET_DOCUMENT_BY_ID } from './base.actions';
import { extendActionWithPostfix } from '@shared/utils';

export const ACTION_FOR_LISTENING = extendActionWithPostfix([
  FETCH_GET_DOCUMENT_BY_ID,
]);
